// Runtime configuration, read from /config.json so one image serves every environment (stage and prod mount
// their own over it). `apiBase` is cp-api's public prefix: `/cp` locally (the Vite proxy) or
// `https://api.stage.blastplus.com/cp` on stage.
export async function loadConfig() {
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) throw new Error(`config.json: ${res.status}`);
  const config = await res.json();
  if (typeof config.apiBase !== 'string') throw new Error('config.json: apiBase missing');
  return { apiBase: config.apiBase.replace(/\/$/, '') };
}
